(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["b2b-nav"] && !Shopify.designMode) return;
  try {
    // B2B Catalog Dropdown - Desktop and Mobile Support
document.addEventListener('DOMContentLoaded', function() {
  console.log('[B2B Nav Debug] DOM Content Loaded');
  
  const b2bDropdown = document.querySelector('.b2b-catalog-dropdown');
  
  if (!b2bDropdown) {
    console.warn('[B2B Nav Debug] B2B dropdown not found');
    return;
  }
  
  const dropdownToggle = b2bDropdown.querySelector('.dropdown-toggle');
  const dropdownMenu = b2bDropdown.querySelector('.dropdown-menu');
  const collectionItems = b2bDropdown.querySelectorAll('.collection-item');
  
  console.log('[B2B Nav Debug] Elements found:', {
    dropdownToggle: !!dropdownToggle,
    dropdownMenu: !!dropdownMenu,
    b2bDropdown: !!b2bDropdown,
    collectionCount: collectionItems.length
  });
  
  // Log collection information
  if (collectionItems.length > 0) {
    console.log('[B2B Nav Debug] Collection items in dropdown:', collectionItems.length);
    collectionItems.forEach((item, index) => {
      const link = item.querySelector('a');
      if (link) {
        console.log(`[B2B Nav Debug] Collection ${index + 1}:`, {
          text: link.textContent.trim(),
          href: link.href
        });
      }
    });
  } else {
    console.warn('[B2B Nav Debug] No collections found in dropdown!');
  }
  
  if (!dropdownToggle || !dropdownMenu) {
    console.warn('[B2B Nav Debug] Dropdown elements not found');
    return;
  }
  
  console.log('[B2B Nav Debug] Setting up dropdown interactions');
  
  // Check if we're on mobile
  function isMobile() {
    return window.innerWidth <= 768;
  }
  
  // Toggle dropdown on click (works for both desktop hover and mobile tap)
  dropdownToggle.addEventListener('click', function(e) {
    if (isMobile()) {
      e.preventDefault();
      e.stopPropagation();
      console.log('[B2B Nav Debug] Mobile - Dropdown toggle clicked');
      dropdownMenu.classList.toggle('show');
      
      // Rotate arrow on mobile
      const arrow = dropdownToggle.querySelector('.dropdown-arrow');
      if (arrow) {
        if (dropdownMenu.classList.contains('show')) {
          arrow.style.transform = 'rotate(180deg)';
        } else {
          arrow.style.transform = 'rotate(0deg)';
        }
      }
    }
  });
  
  // Close dropdown when clicking outside (mobile only)
  document.addEventListener('click', function(e) {
    if (isMobile() && dropdownMenu.classList.contains('show')) {
      if (!b2bDropdown.contains(e.target)) {
        console.log('[B2B Nav Debug] Mobile - Closing dropdown (clicked outside)');
        dropdownMenu.classList.remove('show');
        const arrow = dropdownToggle.querySelector('.dropdown-arrow');
        if (arrow) {
          arrow.style.transform = 'rotate(0deg)';
        }
      }
    }
  });
  
  // Close dropdown on escape key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && dropdownMenu.classList.contains('show')) {
      console.log('[B2B Nav Debug] Closing dropdown (escape key)');
      dropdownMenu.classList.remove('show');
      if (isMobile()) {
        const arrow = dropdownToggle.querySelector('.dropdown-arrow');
        if (arrow) {
          arrow.style.transform = 'rotate(0deg)';
        }
      }
    }
  });
  
  // Handle window resize - close mobile dropdown when switching to desktop
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if (!isMobile() && dropdownMenu.classList.contains('show')) {
        dropdownMenu.classList.remove('show');
        const arrow = dropdownToggle.querySelector('.dropdown-arrow');
        if (arrow) {
          arrow.style.transform = 'rotate(0deg)';
        }
      }
    }, 250);
  });
  
  console.log('[B2B Nav Debug] Dropdown interactions setup complete');
});
  } catch(e) { console.error(e); }
})();

})();
